<template>
  <div>
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="请输入搜索内容"
        v-model.trim="searchName"
        class="handle-input mr10"
      ></el-input>
      <el-select class="mr10" v-model="type" placeholder="请选择" size="small">
        <el-option
          v-for="item in typeOption"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="getData(1)"
        size="small"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column label="文章封面" width="190" align="center">
        <template #default="scope">
          <el-image
            fit="cover"
            v-if="scope.row.image"
            :src="$utils.fileUrl(scope.row.image)"
            :preview-src-list="[`${$utils.fileUrl(scope.row.image)}`]"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column header-align="center" prop="title" label="文章标题">
      </el-table-column>
      <el-table-column label="发布者" align="center" prop="targetName">
      </el-table-column>
      <el-table-column align="center" label="发布时间" width="180px">
        <template #default="scope">
          {{ $utils.formatDate(scope.row.time, "yyyy-MM-dd hh:mm") }}
        </template>
      </el-table-column>
      <el-table-column label="查看详情" align="center" width="120px">
        <template #default="scope">
          <el-button size="mini" type="primary" @click="info(scope.row)"
            >查看详情</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="审核操作" width="180" align="center">
        <template #default="scope">
          <el-button
            type="success"
            size="mini"
            @click="handleEdit(scope.row, 1)"
            >通过</el-button
          >
          <el-button type="danger" size="mini" @click="handleEdit(scope.row, 2)"
            >驳回</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>

    <!-- 详情 -->
    <el-dialog
      title="文章详情"
      v-model="dialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="event_wrap">
        <el-form size="mini" inline label-width="95px">
          <div v-if="itemData.image">
            <el-form-item>
              <div
                class="cover"
                :style="`background-image:url(${$utils.fileUrl(
                  itemData.image
                )})`"
              ></div>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="文章标题：">{{ itemData.title }}</el-form-item>
          </div>
          <div>
            <el-form-item label="发布者：">{{
              itemData.targetName
            }}</el-form-item>
          </div>
          <div>
            <el-form-item label="发布时间：">{{
              $utils.formatDate(itemData.time, "yyyy-MM-dd hh:mm")
            }}</el-form-item>
          </div>
          <div v-if="itemData.targetType===3">
            <el-form-item label="新闻类别：">
              {{
                itemData.type === 1
                  ? "新闻动态"
                  : itemData.type === 3
                  ? "政策法规"
                  : ""
              }}
            </el-form-item>
          </div>
          <div>
            <el-form-item label="公开展示：">{{
              itemData.isShow ? "公开" : "仅自己可见"
            }}</el-form-item>
          </div>
          <div>
            <el-form-item label="文章内容："> </el-form-item>
            <div class="content_wrap w-e-text" v-html="itemData.content"></div>
          </div>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      searchName: "",
      dialogVisible: false,
      itemData: {},
      typeOption: [
        { label: "全部", value: "" },
        { label: "企业", value: 2 },
        { label: "团体", value: 3 },
      ],
      type: "",
    };
  },
  methods: {
    async getData(page = 1) {
      if (this.searchName.length > 30) {
        this.$message.warning("搜索内容最多输入30个字");
        return;
      }
      const params = {
        type: this.type,
        name: this.searchName,
        currentPage: page,
        pageSize: 20,
      };
      try {
        this.$loading.start();
        const res = await this.$api.media.review.getData(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    handleEdit(data, status) {
      if (!this.loading) {
        const text =
          status === 1 ? "是否确认通过审核？" : "是否确认不通过审核？";
        this.$confirm(text, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            try {
              this.loading = true;
              this.$loading.start();
              const params = {
                id: data.id,
                auditStatus: status,
                type: data.targetType,
              };
              const res = await this.$api.media.review.setData(params);
              this.loading = false;
              this.$loading.done();
              if (res.code === 10200) {
                this.getData(this.data.current);
                if (status === 1) {
                  this.$message.success("通过成功");
                } else {
                  this.$message.success("驳回成功！");
                }
              } else {
                this.$message.error(res.msg);
              }
            } catch (error) {
              this.loading = false;
              this.$loading.done();
            }
          })
          .catch(() => {});
      }
    },
    info(data) {
      this.itemData = { ...data };
      this.dialogVisible = true;
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 200px;
  display: inline-block;
}

.handle-box {
  margin-bottom: 20px;

  .el-select {
    width: 180px;
  }
}

.el-image {
  width: 160px;
  height: 90px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.event_wrap {
  .cover-title {
    display: flex;

    .cover {
      margin-right: 24px;
    }

    .title-name {
      li {
        line-height: 26px;
      }
    }
  }

  .el-form-item {
    margin-bottom: 0;
  }
  .content_wrap {
    padding: 0 13px;
  }
}
</style>